/* RESPONSIBLE TEAM: team-pricing-and-packaging */

// https://app.intercom.com/a/apps/tx2p130c/outbound/survey/35064706
export const SELF_SERVE_CHURN_SURVEY_ID = 35064706;
